export default __webpack_public_path__ + "static/media/yes.feea9da6.PNG";